import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Spinner } from 'components';
import Row from '../components/Row';

class InfiniteScrollHoc extends Component {
  static propTypes = { 
    children: PropTypes.any,
    currentPage: PropTypes.number,
    dataLenght: PropTypes.number,
    requestMethod: PropTypes.func,
    perPage: PropTypes.number,
    totalPages: PropTypes.number,
    emptyRender: PropTypes.node
  }

  state = { hasStarted: false }

  nextRequest = () => {
    const { currentPage, requestMethod, perPage } = this.props;
    if (currentPage !== undefined)
      requestMethod(perPage, (currentPage + 1));
  }

  loadingAnimation = (<Row><Spinner height="30vh"/></Row>)

  render() {
    const { 
      children,
      currentPage,
      dataLength,
      totalPages,
      emptyRender
    } = this.props;
     
    return (
      <>
        <InfiniteScroll 
          dataLength={dataLength}
          next={this.nextRequest}
          loader={this.loadingAnimation}
          hasMore={!(currentPage >= totalPages)}
          style={{ overflow: 'visible', paddingBottom: '1rem' }}
          endMessage={ dataLength <= 0 && emptyRender }>
          {children}
        </InfiniteScroll>
      </>
    );
  }
}

export default InfiniteScrollHoc;